<template>
  <el-dialog :visible.sync="show" :modal="false" :close-on-click-modal="false" title="上传文本" width="38%">
    <div class="upload-wapper">
      <div class="flex-row mb10 item-center">
        <div class="col-0 mr10">文件名 <i v-if="error1" class="el-icon-warning error-msg" /></div>
        <el-input v-model="filename" size="mini" class="col-1" />
        <div class="col-0">.doc</div>
      </div>
      <div class="flex-row">
        <div class="col-0 mr10">内容 <i v-if="error2" class="el-icon-warning error-msg" /></div>
        <el-input v-model="text" type="textarea" />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="primary" @click="handleUpload">
        <i class="el-icon-upload el-icon--right" /> 确定
      </el-button>
      <el-button style="margin-left: 10px;" size="medium" @click="close">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    onSuccess: { type: Function, default: () => {} },
    onError: { type: Function, default: () => {} },
  },
  data() {
    return {
      uploadUrl: `${window.host}/bufferUploads`,
      show: false,
      filename: '',
      text: '',
      error1: false,
      error2: false,
    }
  },
  computed: {
    account() {
      return window.app.user.account
    },
  },
  methods: {
    clean() {
      this.filename = ''
      this.text = ''
      this.error1 = false
      this.error2 = false
    },
    visible() {
      this.show = true
    },
    close() {
      this.clean()
      this.show = false
    },
    async handleUpload() {
      const { filename, text } = this
      if (!filename) {
        this.error1 = true
        return
      }
      this.error1 = false
      if (!text) {
        this.error2 = true
        return
      }
      this.error2 = false
      try {
        const { data } = await this.$axios.post(`${window.host}/bufferUploads`, {
          filename: `${filename}.doc`,
          encoding: 'utf8',
          buffer: text,
          uploader: this.account,
          type: '原始简历',
        })
        this.onSuccess(data)
      } catch (error) {
        this.onError(error)
      }
      this.close()
    },
  },
}
</script>

<style scoped>
.error-msg {
  color: #f56c6c;
}
</style>
